(function() {
  'use strict';

  var DELAY_PER_CHILD = 80;
  var SHOP_ALL_URL = '/collections/vintage-surfwear';

  /* ── Strip currency code from price items ─────────────────
     Only currencies whose SYMBOL is unambiguous on its own are stripped -
     GBP, USD, AUD, NZD, CAD, SGD and EUR all keep a leading symbol, so the
     code is redundant clutter on a product card.
     Currencies that render as a bare number or an ambiguous suffix (SEK,
     DKK, NOK, PLN, CZK, HUF, CHF) KEEP their code - stripping those left
     Swedish visitors looking at "445" with no indication of currency. */
  function stripCurrencyNode(node) {
    if (node.nodeType === 3) {
      node.nodeValue = node.nodeValue.replace(/\s*(GBP|USD|AUD|NZD|CAD|SGD|EUR)\s*$/, '');
    } else if (node.nodeType === 1) {
      Array.from(node.childNodes).forEach(stripCurrencyNode);
    }
  }

  function stripAllPrices() {
    document.querySelectorAll('.price-item').forEach(stripCurrencyNode);
  }

  /* ── Point /collections/all links at SHOP ALL ──────────────
     Dawn hardcodes routes.all_products_collection_url in several places
     (cart "Continue shopping", empty cart, 404 page). That resolves to
     /collections/all - Shopify's automatic collection, which contains
     every published product including ~3,500 sold-out ones.
     A URL redirect does not help: Shopify only fires redirects for paths
     that would otherwise 404, and /collections/all always resolves. */
  function retargetAllProductsLinks() {
    var links = document.querySelectorAll('a[href="/collections/all"], a[href$="/collections/all"]');
    links.forEach(function(a) {
      if (a.dataset.sydRetargeted) return;
      a.dataset.sydRetargeted = '1';
      a.setAttribute('href', SHOP_ALL_URL);
    });
  }

  /* ── Scroll reveal ───────────────────────────── */
  function revealCards() {
    var cards = document.querySelectorAll('.card-wrapper:not(.syd-revealed):not(.syd-observed)');
    if (!cards.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var parent = el.parentElement;
        var siblings = parent ? Array.from(parent.querySelectorAll('.card-wrapper')) : [];
        var idx = siblings.indexOf(el);
        var col = idx % 4;
        el.style.transitionDelay = (col * DELAY_PER_CHILD) + 'ms';
        el.classList.add('syd-revealed');
        observer.unobserve(el);
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });

    cards.forEach(function(card) {
      card.classList.add('syd-observed');
      observer.observe(card);
    });
  }

  function init() {
    stripAllPrices();
    retargetAllProductsLinks();
    revealCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 100);
  });

  if (window.MutationObserver) {
    var mo = new MutationObserver(function(mutations) {
      var found = mutations.some(function(m) {
        return Array.from(m.addedNodes).some(function(n) {
          return n.nodeType === 1 && (n.classList && n.classList.contains('card-wrapper') || (n.querySelector && n.querySelector('.card-wrapper')));
        });
      });
      if (found) setTimeout(function() { stripAllPrices(); revealCards(); }, 50);
      retargetAllProductsLinks();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

})();
